<template>
  <div>
    <v-card class="mt-2">
      <v-card-subtitle class="pb-0">
        <div
          class="title pa-2 blue--text text--darken-4"
        >{{ $t('noAccessProfile') }}</div>
        <v-divider></v-divider>
      </v-card-subtitle>
      <v-card-text class="ma-2">
        <div>
          {{ $t('requestAcessAtOrganization') }}
          <ul>
          <li
            class="font-weight-bold"
          >{{ $t('anvisaContact') }}</li>
          <li
            class="font-weight-bold"
          >{{ $t('federalPoliceContact') }}</li>
          <li
            class="font-weight-bold"
          >{{ $t('vigiagroContact') }}</li>
          </ul>
        </div>
        <div>{{ $t('provideDocAndName') }}</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {};
</script>
